import React from 'react';
import { connect } from 'react-redux';

import SignIn from 'src/user-authentication';

const LogIn = ({ params, location }) => (
  <SignIn
    action="login"
    key="login"
    viewParams={{ ...params, query: location.query }}
  />
);

export default connect()(LogIn);
